import { createContext, useCallback, useContext, useEffect, useState } from 'react'

type TrackReportUpload = (field: string, isUploading: boolean) => void

export const ReportUploadsContext = createContext<TrackReportUpload>(() => undefined)

/** Which of the report form's fields are uploading, so the page can hold Save until they are done. */
export const useReportUploads = () => {
  const [fields, setFields] = useState<string[]>([])
  const track = useCallback<TrackReportUpload>(
    (field, isUploading) =>
      setFields((current) => {
        if (isUploading) return current.includes(field) ? current : [...current, field]
        return current.includes(field) ? current.filter((name) => name !== field) : current
      }),
    []
  )
  return { isUploading: fields.length > 0, track }
}

export const useTrackReportUpload = (field: string, isUploading: boolean) => {
  const track = useContext(ReportUploadsContext)
  useEffect(() => {
    if (!isUploading) return
    track(field, true)
    return () => track(field, false)
  }, [field, isUploading, track])
}
